<template>
  <div id="speakToStudent" class="speakToStudent" :class="calling === 0 ? 'speakToStudentAn':calling === 1  || calling === 2?'speakToStudentCl':''">
    <div class="speakBox" :class="calling === 1 || calling === 2 ? 'speakBoxAn':''">
      <img class="callingImg" :src="calling !== 2 ? 'https://img.webloom.cn/img/callPhone.png' : 'https://img.webloom.cn/img/stopCall.png'" alt="">
      <div class="speakText">
        <div>{{$t(calling === 0 ? 'speakToStudent.willSpeak' : calling === 1 ? 'speakToStudent.connecting' : calling === 2 ? 'speakToStudent.hangUp' :'')}}</div>
        <div v-if="calling === 0" class="times">{{time}}s</div>
      </div>
    </div>
    <div v-show="false" id="audioSpeakToStudent"></div>
  </div>
</template>

<script>
import TIM from 'tim-js-sdk'
import {mapState, mapMutations} from 'vuex'
import {create, onTRTC, enterRoom, startLocal, exitRoom} from './createTrtcV5'
import {createTextMessage, sendMessage} from './createIMClient'
export default {
  props: {
    showHelp: false
  },
  watch: {
    connectObj: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && val.examId && val.examId === this.$route.query.examId && val.voiceStartTime && val.voiceStartTime > this.nowDate && this.showHelp) {
          let streamObj = { transactionId: val.examId, userId: val.userId, notUploadDesc: true }
          this.set_streamObj(streamObj)
          setTimeout(() => {
            create(streamObj, trtc => {
              this.client = trtc
              onTRTC(streamObj, trtc, 'startLocalAudio', ['ERROR', 'KICKED_OUT'], onTrtc => {
                if (onTrtc && onTrtc.msg) this.sendMessagePage(onTrtc.msg, val.userId, val.adminUserId)
                else this.closePhone()
              }, err => {
                if (err && err.msg) this.sendMessagePage(err.msg, val.userId, val.adminUserId)
                else this.closePhone()
              })
              enterRoom(streamObj, trtc, val.videoRoomId, Number(val.sdkAppId), val.userId, val.videoUserSig, enterRoom => {
                trtc.muteRemoteAudio('*', true)
                this.timer = setInterval(() => {
                  this.time = parseInt((val.voiceStartTime - this.nowDate) / 1000)
                  this.calling = 0
                  if (this.time <= 0) {
                  // 倒计时结束，打开音频播放
                    trtc.muteRemoteAudio('*', false)
                    clearInterval(this.timer)
                    this.calling = 1
                    this.addOnMouse()
                    this.set_isStopAudio(true)
                  }
                }, 1000)
                this.set_connectClient(trtc)
              }, e => { console.log(e) })
              startLocal(streamObj, trtc, 'startLocalAudio', '', {}, true, false, res => {
                this.set_connectStream(res)
              }, err1 => {
                if (err1 && err1.msg) this.sendMessagePage(err1.msg, val.userId, val.adminUserId)
              })
            }, err => {
              if (err && err.msg) this.sendMessagePage(err.msg, val.userId, val.adminUserId)
              else this.closePhone()
            })
          }, 1000)
        }
      }
    }
  },
  computed: mapState({
    connectObj: state => state.proctor.connectObj,
    nowDate: state => state.common.nowDate
  }),
  data () {
    return {
      calling: -1,   // -1：没有连线；0：连线中；1：已连线；2：已挂断
      time: 0,
      timer: null,
      client: null
    }
  },
  components: {},
  mounted () {},
  methods: {
    ...mapMutations(['set_connectClient', 'set_connectStream', 'set_isStopAudio', 'set_streamObj']),
    closePhone () {
      if (this.timer) clearInterval(this.timer)
      this.set_isStopAudio(false)
      this.calling = 2
      setTimeout(() => {
        this.calling = -1
        var box = document.getElementById('speakToStudent')
        if (box) box.style = null
      }, 1000)
    },
    muteToggle () {
      let myVideo = document.getElementById('audioSpeakToStudent') && document.getElementById('audioSpeakToStudent').childNodes[0] && document.getElementById('audioSpeakToStudent').childNodes[0].childNodes[0] ? document.getElementById('audioSpeakToStudent').childNodes[0].childNodes[0] : ''
      if (myVideo) {
        if (myVideo.nodeName !== 'AUDIO') myVideo = document.getElementById('audioSpeakToStudent').childNodes[0].childNodes[1]
        if (myVideo.volume === 0) myVideo.volume = 1
        else myVideo.volume = 0
        console.log('我不知道被静止还是被播放', myVideo.volume)
      }
    },
    sendMessagePage (reason, userId, adminUserId) {
      let msg = {
        msgType: 780,
        examId: this.$route.query.examId,
        reason,
        userId
      }
      createTextMessage(adminUserId, TIM.TYPES.CONV_C2C, JSON.stringify(msg), imResponse => {
        sendMessage(imResponse, imResponse1 => {
          // 发送成功
          console.log(imResponse1, '发送成功')
        })
      })
    },
    addOnMouse () {
      let self = this
      this.$nextTick(() => {
        var box = document.getElementById('speakToStudent')
        var fa = document.getElementById('app')
        // 图片移动效果
        box.onmousedown = function (ev) {
          var oEvent = ev
          // 浏览器有一些图片的默认事件,这里要阻止
          oEvent.preventDefault()
          var disX = oEvent.clientX - box.offsetLeft
          var disY = oEvent.clientY - box.offsetTop
          fa.onmousemove = function (ev) {
            oEvent = ev
            oEvent.preventDefault()
            var x = oEvent.clientX - disX
            var y = oEvent.clientY - disY
            // top为0或负数，left为0或负数
            if (y <= 0) y = 0
            if (x <= 0) x = 0
            console.log(y, box.clientHeight, y + box.clientHeight, fa.clientHeight)
            if (x + box.clientWidth >= fa.clientWidth) x = fa.clientWidth - box.clientWidth
            if (y + box.clientHeight >= fa.clientHeight) y = fa.clientHeight - box.clientHeight
            if (self.calling === 1) {
              box.style.position = 'fixed'
              box.style.left = x + 'px'
              box.style.top = y + 'px'
              console.log(x, fa.clientWidth)
              box.animate = null
            }
            console.log(box)
          }
          // 图形移出父盒子取消移动事件,防止移动过快触发鼠标移出事件,导致鼠标弹起事件失效
          fa.onmouseleave = function () {
            fa.onmousemove = null
            fa.onmouseup = null
          }
          // 鼠标弹起后停止移动
          fa.onmouseup = function () {
            fa.onmousemove = null
            fa.onmouseup = null
          }
        }
      })
    }
  },
  beforeDestroy () {
    exitRoom({}, this.client, {}, res => {}, err => { console.error(err) })
  }
}

</script>

<style scoped lang="scss">
$width:100vw/1920;
.speakToStudent{
  width: fit-content;
  height: fit-content;
  position: fixed;
  top:244*$width;
  right: -300*$width;
  font-family: PingFangSC-Regular, PingFang SC;
  .speakBox{
    padding: 15*$width 0 12*$width 12*$width;
    display: flex;
    align-items: center;
    width: 220*$width;
    height: 69*$width;
    background: #FFFFFF;
    border-radius: 4*$width;
    box-shadow: 0px 3px 7px 0px #9CA0A8;
    box-sizing: border-box;
    .callingImg{
      width: 42*$width;
      height: 42*$width;
      margin-right: 14*$width;
    }
    .speakText{
      width: 140*$width;
      font-size: 14*$width;
      font-weight: 400;
      color: #343A40;
      line-height: 20*$width;
    }
    .times{
      margin-top: 3*$width;
    }
  }
  .speakBoxAn{
    animation: speakBoxAnKey 1s forwards;
  }
  @keyframes speakBoxAnKey {
    0%{
      width: 220*$width;
      height: 69*$width;
    }
    100%{
      width: 158*$width;
      height: 69*$width;
    }
  }
}
.speakToStudentAn{
  animation: speakToAn 1s forwards;
}
.speakToStudentCl{
  position: fixed !important;
  top:244*$width;
  right: 32*$width;
}
@keyframes speakToAn {
  0%{
    position: fixed;
    top:244*$width;
    right: -300*$width;
  }
  100%{
    position: fixed;
    top:244*$width;
    right: 32*$width;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bloom-proctor/public/speakToStudent.vue